export const ctfPosts = [
  {
    id: 'c1',
    user_id: 'user81',
    type: 'feed' as const,
    category: 'ctf',
    title: 'DEF CON 32 CTF Finals 후기 - 1등 팀 PPP의 전략 분석',
    content: 'DEF CON 32 CTF Finals에서 우승한 PPP 팀의 전략을 분석했습니다. 특히 kernel exploitation 문제에서 보여준 빠른 분석 능력과 팀워크가 인상적이었습니다. 실제 문제 풀이 과정과 함께 대회 준비 노하우를 공유합니다.',
    tags: ['defcon', 'ctf', 'finals', 'ppp', 'kernel-exploit'],
    status: 'open',
    is_pinned: false,
    likes_count: 2345,
    replies_count: 89,
    views_count: 18700,
    created_at: new Date(Date.now() - 1 * 3600000).toISOString(),
    profiles: {
      id: 'user81',
      username: 'ctf_champion',
      display_name: 'CTF Champion',
      points: 18450,
      reputation: 5670
    }
  },
  {
    id: 'c2',
    user_id: 'user82',
    type: 'feed' as const,
    category: 'ctf',
    title: 'Google CTF 2025 Pwn 문제 "SafeBox" Write-up',
    content: 'Google CTF 2025의 가장 어려웠던 Pwn 문제 SafeBox의 상세 풀이입니다. Rust로 작성된 바이너리의 메모리 안전성을 우회하는 독특한 접근이 필요했습니다. unsafe 블록의 미묘한 버그를 찾아 익스플로잇하는 전 과정을 공유합니다.',
    tags: ['google-ctf', 'pwn', 'rust', 'memory-safety', 'writeup'],
    status: 'open',
    is_pinned: false,
    likes_count: 1876,
    replies_count: 72,
    views_count: 15300,
    created_at: new Date(Date.now() - 3 * 3600000).toISOString(),
    profiles: {
      id: 'user82',
      username: 'pwn_master',
      display_name: 'Pwn Master',
      points: 16780,
      reputation: 5120
    }
  },
  {
    id: 'c3',
    user_id: 'user83',
    type: 'feed' as const,
    category: 'ctf',
    title: 'HITCON CTF 2025 Crypto 문제 "Quantum RSA" 풀이',
    content: 'HITCON CTF의 고난이도 암호학 문제입니다. 양자 컴퓨터 시뮬레이션 환경에서 RSA를 공격하는 독특한 설정이었습니다. Shor 알고리즘의 변형을 구현하여 해결했으며, 실제 양자 암호학 개념도 함께 설명합니다.',
    tags: ['hitcon', 'crypto', 'quantum', 'rsa', 'shor-algorithm'],
    status: 'open',
    is_pinned: false,
    likes_count: 1567,
    replies_count: 64,
    views_count: 12800,
    created_at: new Date(Date.now() - 5 * 3600000).toISOString(),
    profiles: {
      id: 'user83',
      username: 'crypto_wizard',
      display_name: 'Crypto Wizard',
      points: 15230,
      reputation: 4680
    }
  },
  {
    id: 'c4',
    user_id: 'user84',
    type: 'feed' as const,
    category: 'ctf',
    title: 'PlaidCTF 2025 Web 문제 "GraphQL Hell" 상세 분석',
    content: 'PlaidCTF의 복잡한 GraphQL 보안 문제를 풀이합니다. 중첩된 쿼리 깊이 제한 우회, 배치 쿼리 타이밍 공격, 그리고 introspection 비활성화 우회까지 다양한 기법이 필요했습니다. 실전에서도 유용한 GraphQL 공격 기법을 배울 수 있습니다.',
    tags: ['plaidctf', 'web', 'graphql', 'timing-attack', 'introspection'],
    status: 'open',
    is_pinned: false,
    likes_count: 1789,
    replies_count: 68,
    views_count: 14100,
    created_at: new Date(Date.now() - 7 * 3600000).toISOString(),
    profiles: {
      id: 'user84',
      username: 'web_hacker',
      display_name: 'Web Hacker',
      points: 14670,
      reputation: 4450
    }
  },
  {
    id: 'c5',
    user_id: 'user85',
    type: 'feed' as const,
    category: 'ctf',
    title: 'CODEGATE 2025 Reversing 문제 "VM Obfuscation" 공략',
    content: 'CODEGATE의 가상 머신 기반 난독화 문제입니다. 커스텀 VM의 명령어 셋을 리버싱하고, 중첩된 암호화 레이어를 벗겨내는 과정이 필요했습니다. IDA Pro와 Unicorn Engine을 활용한 동적 분석 기법을 공유합니다.',
    tags: ['codegate', 'reversing', 'vm-obfuscation', 'ida-pro', 'unicorn'],
    status: 'open',
    is_pinned: false,
    likes_count: 1456,
    replies_count: 57,
    views_count: 11200,
    created_at: new Date(Date.now() - 9 * 3600000).toISOString(),
    profiles: {
      id: 'user85',
      username: 'reverse_ninja',
      display_name: 'Reverse Ninja',
      points: 13890,
      reputation: 4230
    }
  },
  {
    id: 'c6',
    user_id: 'user86',
    type: 'feed' as const,
    category: 'ctf',
    title: 'SECCON CTF 2025 Forensics 문제 "Memory Dump" 풀이',
    content: 'SECCON의 메모리 포렌식 문제입니다. Windows 11 메모리 덤프에서 랜섬웨어 감염 흔적을 찾고, 암호화 키를 복구하는 과정이 필요했습니다. Volatility 3와 커스텀 플러그인을 활용한 분석 과정을 상세히 설명합니다.',
    tags: ['seccon', 'forensics', 'memory-dump', 'volatility', 'ransomware'],
    status: 'open',
    is_pinned: false,
    likes_count: 1678,
    replies_count: 62,
    views_count: 12900,
    created_at: new Date(Date.now() - 11 * 3600000).toISOString(),
    profiles: {
      id: 'user86',
      username: 'forensics_expert',
      display_name: 'Forensics Expert',
      points: 12670,
      reputation: 3890
    }
  },
  {
    id: 'c7',
    user_id: 'user87',
    type: 'feed' as const,
    category: 'ctf',
    title: 'CSAW CTF 2025 Binary Exploitation 초보자 가이드',
    content: 'CSAW CTF의 입문자용 Pwn 문제들을 단계별로 풀이합니다. 스택 오버플로우, ROP 체인, ASLR 우회 등 기본 개념부터 차근차근 설명하며, pwntools를 활용한 익스플로잇 작성법도 함께 다룹니다. CTF 입문자에게 추천합니다.',
    tags: ['csaw', 'pwn', 'beginner', 'rop', 'pwntools'],
    status: 'open',
    is_pinned: false,
    likes_count: 2123,
    replies_count: 86,
    views_count: 17400,
    created_at: new Date(Date.now() - 13 * 3600000).toISOString(),
    profiles: {
      id: 'user87',
      username: 'ctf_teacher',
      display_name: 'CTF Teacher',
      points: 11450,
      reputation: 3450
    }
  },
  {
    id: 'c8',
    user_id: 'user88',
    type: 'feed' as const,
    category: 'ctf',
    title: 'picoCTF 2025 Cryptography 전체 문제 풀이 모음',
    content: 'picoCTF 2025의 모든 암호학 문제를 난이도별로 정리했습니다. 고전 암호부터 현대 암호까지, RSA 공격, AES 사이드채널, 해시 충돌 등 다양한 주제를 다룹니다. 각 문제마다 상세한 풀이와 함께 관련 이론도 설명합니다.',
    tags: ['picoctf', 'crypto', 'rsa', 'aes', 'hash-collision'],
    status: 'open',
    is_pinned: false,
    likes_count: 1890,
    replies_count: 74,
    views_count: 15600,
    created_at: new Date(Date.now() - 15 * 3600000).toISOString(),
    profiles: {
      id: 'user88',
      username: 'crypto_solver',
      display_name: 'Crypto Solver',
      points: 10890,
      reputation: 3290
    }
  },
  {
    id: 'c9',
    user_id: 'user89',
    type: 'feed' as const,
    category: 'ctf',
    title: 'HackTheBox Cyber Apocalypse CTF 2025 - 팀 전략 공유',
    content: 'HTB Cyber Apocalypse CTF에서 상위 10위 안에 든 우리 팀의 전략을 공유합니다. 역할 분담, 커뮤니케이션 방법, 문제 우선순위 결정 기준 등 팀 CTF에서 중요한 요소들을 다룹니다. 실제 대회 중 Discord 로그도 일부 공개합니다.',
    tags: ['hackthebox', 'team-ctf', 'strategy', 'communication', 'cyber-apocalypse'],
    status: 'open',
    is_pinned: false,
    likes_count: 1567,
    replies_count: 61,
    views_count: 12300,
    created_at: new Date(Date.now() - 17 * 3600000).toISOString(),
    profiles: {
      id: 'user89',
      username: 'team_leader',
      display_name: 'Team Leader',
      points: 13450,
      reputation: 4120
    }
  },
  {
    id: 'c10',
    user_id: 'user90',
    type: 'feed' as const,
    category: 'ctf',
    title: 'RCTF 2025 Misc 문제 "Blockchain Puzzle" 독특한 풀이',
    content: 'RCTF의 블록체인 기반 퍼즐 문제입니다. 스마트 컨트랙트의 논리적 취약점을 찾아 Reentrancy 공격을 수행해야 했습니다. Solidity 코드 분석부터 Remix IDE를 활용한 익스플로잇까지 전 과정을 설명합니다.',
    tags: ['rctf', 'misc', 'blockchain', 'smart-contract', 'reentrancy'],
    status: 'open',
    is_pinned: false,
    likes_count: 1456,
    replies_count: 54,
    views_count: 10800,
    created_at: new Date(Date.now() - 19 * 3600000).toISOString(),
    profiles: {
      id: 'user90',
      username: 'blockchain_hacker',
      display_name: 'Blockchain Hacker',
      points: 12340,
      reputation: 3780
    }
  },
  {
    id: 'c11',
    user_id: 'user91',
    type: 'feed' as const,
    category: 'ctf',
    title: 'ångstromCTF 2025 Web 문제 "JWT Confusion" 풀이',
    content: 'JWT 알고리즘 혼동 공격을 다루는 웹 문제입니다. RS256에서 HS256으로 알고리즘을 변경하여 공개키를 HMAC 시크릿으로 사용하는 클래식한 공격입니다. 실제 웹 애플리케이션에서도 자주 발견되는 취약점이므로 실전에서도 유용합니다.',
    tags: ['angstromctf', 'web', 'jwt', 'algorithm-confusion', 'hmac'],
    status: 'open',
    is_pinned: false,
    likes_count: 1789,
    replies_count: 67,
    views_count: 13700,
    created_at: new Date(Date.now() - 21 * 3600000).toISOString(),
    profiles: {
      id: 'user91',
      username: 'jwt_breaker',
      display_name: 'JWT Breaker',
      points: 11670,
      reputation: 3560
    }
  },
  {
    id: 'c12',
    user_id: 'user92',
    type: 'feed' as const,
    category: 'ctf',
    title: 'DiceCTF 2025 Pwn 문제 "Kernel ROP" 고급 기법',
    content: 'DiceCTF의 커널 익스플로잇 문제입니다. SMEP, SMAP, KPTI가 모두 활성화된 환경에서 ROP 체인을 구성하는 고급 기법이 필요했습니다. ret2usr 공격의 현대적 변형과 함께 커널 디버깅 팁도 공유합니다.',
    tags: ['dicectf', 'pwn', 'kernel', 'rop', 'smep-smap'],
    status: 'open',
    is_pinned: false,
    likes_count: 2234,
    replies_count: 83,
    views_count: 17900,
    created_at: new Date(Date.now() - 23 * 3600000).toISOString(),
    profiles: {
      id: 'user92',
      username: 'kernel_pwner',
      display_name: 'Kernel Pwner',
      points: 17230,
      reputation: 5340
    }
  },
  {
    id: 'c13',
    user_id: 'user93',
    type: 'feed' as const,
    category: 'ctf',
    title: 'UIUCTF 2025 OSINT 문제 "Find the Hacker" 풀이 과정',
    content: 'OSINT 문제로 실제 해커의 위치를 추적하는 시나리오입니다. 소셜 미디어 메타데이터 분석, 이미지 역검색, 지리적 단서 조합 등 다양한 OSINT 기법을 활용했습니다. 실전 위협 인텔리전스에서도 사용되는 방법론입니다.',
    tags: ['uiuctf', 'osint', 'geolocation', 'social-media', 'metadata'],
    status: 'open',
    is_pinned: false,
    likes_count: 1678,
    replies_count: 64,
    views_count: 13100,
    created_at: new Date(Date.now() - 25 * 3600000).toISOString(),
    profiles: {
      id: 'user93',
      username: 'osint_detective',
      display_name: 'OSINT Detective',
      points: 12890,
      reputation: 3890
    }
  },
  {
    id: 'c14',
    user_id: 'user94',
    type: 'feed' as const,
    category: 'ctf',
    title: 'BSidesSF CTF 2025 Hardware 문제 "FPGA Challenge" 분석',
    content: 'FPGA 기반 하드웨어 보안 문제입니다. Verilog 코드를 분석하여 하드웨어 백도어를 찾아내고, 타이밍 공격으로 시크릿 키를 추출하는 과정이 필요했습니다. 하드웨어 보안의 기초부터 고급 공격 기법까지 다룹니다.',
    tags: ['bsidessf', 'hardware', 'fpga', 'verilog', 'timing-attack'],
    status: 'open',
    is_pinned: false,
    likes_count: 1456,
    replies_count: 56,
    views_count: 10900,
    created_at: new Date(Date.now() - 27 * 3600000).toISOString(),
    profiles: {
      id: 'user94',
      username: 'hardware_hacker',
      display_name: 'Hardware Hacker',
      points: 14230,
      reputation: 4340
    }
  },
  {
    id: 'c15',
    user_id: 'user95',
    type: 'feed' as const,
    category: 'ctf',
    title: 'NahamCon CTF 2025 Mobile 문제 "Android Obfuscation" 공략',
    content: 'NahamCon의 안드로이드 리버싱 문제입니다. ProGuard와 DexGuard로 이중 난독화된 APK를 분석해야 했습니다. Frida를 활용한 동적 분석과 Jadx 디컴파일 결과를 조합하여 해결한 과정을 공유합니다.',
    tags: ['nahamcon', 'mobile', 'android', 'obfuscation', 'frida'],
    status: 'open',
    is_pinned: false,
    likes_count: 1567,
    replies_count: 59,
    views_count: 11800,
    created_at: new Date(Date.now() - 29 * 3600000).toISOString(),
    profiles: {
      id: 'user95',
      username: 'mobile_reverser',
      display_name: 'Mobile Reverser',
      points: 11450,
      reputation: 3450
    }
  },
  {
    id: 'c16',
    user_id: 'user96',
    type: 'feed' as const,
    category: 'ctf',
    title: 'ASIS CTF 2025 Crypto 문제 "Lattice Attack" 수학적 접근',
    content: 'ASIS CTF의 고난이도 격자 기반 암호 문제입니다. LLL 알고리즘을 활용한 격자 축소 공격으로 RSA 개인키를 복구하는 과정이 필요했습니다. SageMath를 사용한 구현과 함께 격자 암호학의 기초 이론도 설명합니다.',
    tags: ['asis', 'crypto', 'lattice', 'lll-algorithm', 'sagemath'],
    status: 'open',
    is_pinned: false,
    likes_count: 1890,
    replies_count: 71,
    views_count: 14600,
    created_at: new Date(Date.now() - 31 * 3600000).toISOString(),
    profiles: {
      id: 'user96',
      username: 'math_cryptographer',
      display_name: 'Math Cryptographer',
      points: 15670,
      reputation: 4780
    }
  },
  {
    id: 'c17',
    user_id: 'user97',
    type: 'feed' as const,
    category: 'ctf',
    title: 'TetCTF 2025 Web 문제 "SSRF to RCE" 체인 공격',
    content: 'TetCTF의 복잡한 웹 공격 체인 문제입니다. SSRF로 내부 Redis에 접근하고, Lua 스크립트 인젝션을 통해 최종적으로 RCE를 달성하는 과정이 필요했습니다. 실제 프로덕션 환경에서도 발견되는 공격 패턴입니다.',
    tags: ['tetctf', 'web', 'ssrf', 'redis', 'rce-chain'],
    status: 'open',
    is_pinned: false,
    likes_count: 2123,
    replies_count: 78,
    views_count: 16800,
    created_at: new Date(Date.now() - 33 * 3600000).toISOString(),
    profiles: {
      id: 'user97',
      username: 'chain_attacker',
      display_name: 'Chain Attacker',
      points: 14670,
      reputation: 4450
    }
  },
  {
    id: 'c18',
    user_id: 'user98',
    type: 'feed' as const,
    category: 'ctf',
    title: 'Midnight Sun CTF 2025 Reversing "Anti-Debug" 우회 기법',
    content: 'Midnight Sun CTF의 안티 디버깅 문제입니다. ptrace 탐지, 타이밍 체크, 하드웨어 브레이크포인트 탐지 등 다양한 안티 디버깅 기법이 적용되어 있었습니다. 각 보호 기법을 우회하는 방법과 함께 자동화 스크립트를 공유합니다.',
    tags: ['midnight-sun', 'reversing', 'anti-debug', 'ptrace', 'bypass'],
    status: 'open',
    is_pinned: false,
    likes_count: 1678,
    replies_count: 63,
    views_count: 12700,
    created_at: new Date(Date.now() - 35 * 3600000).toISOString(),
    profiles: {
      id: 'user98',
      username: 'debug_master',
      display_name: 'Debug Master',
      points: 13890,
      reputation: 4230
    }
  },
  {
    id: 'c19',
    user_id: 'user99',
    type: 'feed' as const,
    category: 'ctf',
    title: 'Insomni\'hack CTF 2025 Pwn "Heap Feng Shui" 고급 기법',
    content: 'Insomni\'hack의 힙 익스플로잇 문제입니다. tcache poisoning과 unsorted bin attack을 조합한 복잡한 힙 조작이 필요했습니다. glibc 2.35의 최신 보호 기법을 우회하는 방법과 함께 힙 디버깅 팁을 공유합니다.',
    tags: ['insomnihack', 'pwn', 'heap', 'tcache', 'glibc'],
    status: 'open',
    is_pinned: false,
    likes_count: 2345,
    replies_count: 87,
    views_count: 18900,
    created_at: new Date(Date.now() - 37 * 3600000).toISOString(),
    profiles: {
      id: 'user99',
      username: 'heap_wizard',
      display_name: 'Heap Wizard',
      points: 16890,
      reputation: 5120
    }
  },
  {
    id: 'c20',
    user_id: 'user100',
    type: 'feed' as const,
    category: 'ctf',
    title: 'ALLES! CTF 2025 Misc 문제 "Esoteric Language" 독특한 풀이',
    content: 'ALLES! CTF의 난해한 프로그래밍 언어 문제입니다. Brainfuck의 변형 언어로 작성된 프로그램을 분석하고, 숨겨진 플래그를 추출하는 과정이 필요했습니다. 인터프리터를 직접 구현하여 해결한 과정을 공유합니다.',
    tags: ['alles', 'misc', 'esoteric', 'brainfuck', 'interpreter'],
    status: 'open',
    is_pinned: false,
    likes_count: 1456,
    replies_count: 52,
    views_count: 10300,
    created_at: new Date(Date.now() - 39 * 3600000).toISOString(),
    profiles: {
      id: 'user100',
      username: 'esolang_expert',
      display_name: 'Esolang Expert',
      points: 10670,
      reputation: 3230
    }
  },
  {
    id: 'c21',
    user_id: 'user101',
    type: 'feed' as const,
    category: 'ctf',
    title: 'CyberSecurityRumble 2025 Forensics "Network PCAP" 분석',
    content: 'CyberSecurityRumble의 네트워크 포렌식 문제입니다. 대용량 PCAP 파일에서 암호화된 C2 통신을 찾아내고, 트래픽 패턴 분석으로 멀웨어 행동을 재구성하는 과정이 필요했습니다. Wireshark와 tshark를 활용한 분석 기법을 공유합니다.',
    tags: ['cybersecurityrumble', 'forensics', 'pcap', 'wireshark', 'c2-analysis'],
    status: 'open',
    is_pinned: false,
    likes_count: 1567,
    replies_count: 58,
    views_count: 11600,
    created_at: new Date(Date.now() - 41 * 3600000).toISOString(),
    profiles: {
      id: 'user101',
      username: 'pcap_analyzer',
      display_name: 'PCAP Analyzer',
      points: 12450,
      reputation: 3780
    }
  },
  {
    id: 'c22',
    user_id: 'user102',
    type: 'feed' as const,
    category: 'ctf',
    title: 'CUCTF 2025 Web 문제 "GraphQL Injection" 심화 공격',
    content: 'CUCTF의 GraphQL 인젝션 문제입니다. 배치 쿼리를 악용한 SQL Injection과 N+1 쿼리 문제를 결합한 복잡한 공격이 필요했습니다. GraphQL의 보안 취약점과 함께 안전한 구현 방법도 설명합니다.',
    tags: ['cuctf', 'web', 'graphql', 'sql-injection', 'batch-query'],
    status: 'open',
    is_pinned: false,
    likes_count: 1789,
    replies_count: 66,
    views_count: 13400,
    created_at: new Date(Date.now() - 43 * 3600000).toISOString(),
    profiles: {
      id: 'user102',
      username: 'graphql_hacker',
      display_name: 'GraphQL Hacker',
      points: 11230,
      reputation: 3410
    }
  },
  {
    id: 'c23',
    user_id: 'user103',
    type: 'feed' as const,
    category: 'ctf',
    title: 'TSG CTF 2025 Pwn 문제 "Browser Exploitation" 풀이',
    content: 'TSG CTF의 브라우저 익스플로잇 문제입니다. V8 JavaScript 엔진의 JIT 컴파일러 버그를 악용하여 임의 코드 실행을 달성하는 과정이 필요했습니다. 브라우저 익스플로잇의 기초부터 고급 기법까지 상세히 설명합니다.',
    tags: ['tsg', 'pwn', 'browser', 'v8', 'jit-compiler'],
    status: 'open',
    is_pinned: false,
    likes_count: 2456,
    replies_count: 91,
    views_count: 19700,
    created_at: new Date(Date.now() - 45 * 3600000).toISOString(),
    profiles: {
      id: 'user103',
      username: 'browser_pwner',
      display_name: 'Browser Pwner',
      points: 18450,
      reputation: 5670
    }
  },
  {
    id: 'c24',
    user_id: 'user104',
    type: 'feed' as const,
    category: 'ctf',
    title: 'DUCTF 2025 Crypto 문제 "Side Channel Attack" 실전 적용',
    content: 'DUCTF의 사이드채널 공격 문제입니다. AES 구현의 타이밍 차이를 측정하여 암호화 키를 추출하는 과정이 필요했습니다. 통계적 분석 방법과 함께 실제 하드웨어에서의 사이드채널 공격 기법도 설명합니다.',
    tags: ['ductf', 'crypto', 'side-channel', 'timing-attack', 'aes'],
    status: 'open',
    is_pinned: false,
    likes_count: 1678,
    replies_count: 63,
    views_count: 12900,
    created_at: new Date(Date.now() - 47 * 3600000).toISOString(),
    profiles: {
      id: 'user104',
      username: 'sidechannel_pro',
      display_name: 'Side Channel Pro',
      points: 14230,
      reputation: 4340
    }
  },
  {
    id: 'c25',
    user_id: 'user105',
    type: 'feed' as const,
    category: 'ctf',
    title: 'CTF 입문자를 위한 완벽 가이드 - 공부 로드맵과 추천 자료',
    content: 'CTF를 시작하는 분들을 위한 종합 가이드입니다. 카테고리별 학습 순서, 추천 연습 사이트, 필수 도구 목록, 그리고 실력 향상을 위한 팁을 정리했습니다. 초보자부터 중급자까지 단계별로 성장할 수 있는 로드맵을 제시합니다.',
    tags: ['ctf', 'beginner', 'guide', 'roadmap', 'learning'],
    status: 'open',
    is_pinned: false,
    likes_count: 3124,
    replies_count: 112,
    views_count: 25600,
    created_at: new Date(Date.now() - 49 * 3600000).toISOString(),
    profiles: {
      id: 'user105',
      username: 'ctf_mentor',
      display_name: 'CTF Mentor',
      points: 9890,
      reputation: 2980
    }
  }
];